export default "__VITE_ASSET__DfJhVVI2__"